// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"9219e61a","99":"12a2b8f3","231":"0af454bf","365":"e785c50f","661":"f520ed67","723":"5710d2d3","757":"507180a7","882":"68561afa"}[chunkId] + ".chunk.js";
};